/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Transfer } from "./Transfer";
import * as t from "io-ts";

// required attributes
const BundleOptionR = t.interface({});

// optional attributes
const BundleOptionO = t.partial({
  belowThreshold: t.boolean,

  bundleOptions: t.readonlyArray(Transfer, "array of Transfer")
});

export const BundleOption = t.intersection(
  [BundleOptionR, BundleOptionO],
  "BundleOption"
);

export type BundleOption = t.TypeOf<typeof BundleOption>;
